import declare from	"dojo/_base/declare";
import Controller from "csi/action/Controller";
import xml from	"csi/xml";
import { CallMethod } from "csi/xml/CallMethod";

const CalculateBatchController = declare(Controller, {

	/**
     * @override
     * Add Parameter URL with the value of Recipe Revision - Master
     */
	toWriterRequest: function() {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("URL", xml.ATTR_REF, this.getParent().__Parent__);
		return call;
	},
    
});

export = CalculateBatchController;